//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[1,"ExistingCurves",0,"Section",0],[0,"ProjectDirection",0,"GeometricUtilities.ProjectionOptions",0]],[[["bodyArray"],"AddCurveOnBodies",{},1,0],[["nCurves"],"CreateSplitCurveWithUseExisting",{R_:{curves:"Spline[]"}},0,0]],[]];
SPLM.Facet.SplitCurveMethodBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.SplitCurveMethodBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.SplitCurveMethodBuilder.ProjectOption = Object.freeze({
    "NormalToFace" : "NormalToFace", "AlongVector" : "AlongVector"});

export default SPLM;